import { SidebarNavGroup } from "src/components/SidebarSidebarNavGroup";
import { type SidebarGroupConfig } from "src/staticData";

interface SidebarGroupsProps {
  groups: SidebarGroupConfig[];
}
export function SidebarGroups(props: SidebarGroupsProps) {
  return (
    <>
      {props.groups.map((group) => {
        return <SidebarNavGroup group={group} key={group.id} />;
      })}
    </>
  );
}
